import React, { useState, useEffect } from 'react'
import axios from 'axios'
import jwt_decode from 'jwt-decode'
import Dasnav from '../components/Dasnav'
import Footer from '../components/Footer'

export default function ManageContact() {
  var token = localStorage.getItem('token')
  if (token) {
    var decoded = jwt_decode(token)
    // console.log(decoded)
  }
  if (decoded.user.email !== process.env.REACT_APP_ADMIN) {
    window.location.pathname = '/dashboard'
  }

  const [Contact, setContact] = useState([])

  useEffect(() => {
    axios
      .get('/admin/contact', {
        headers: { token },
      })
      .then(res => setContact(res.data))
      .catch(err => console.log(err))
  }, [token])
  console.log(Contact)

  return (
    <div>
      <Dasnav />
      <table>
        <tr>
          <th>Id</th>
          <th>Email</th>
          <th>Name</th>
          <th>message</th>
          <th>budget</th>
          <th>website</th>
          <th>createdAt</th>
        </tr>
        {Contact.map(item => {
          return (
            <tr key={item._id}>
              <td>{item._id}</td>
              <td>{item.email}</td>
              <td>{item.name}</td>
              <td>{item.message}</td>
              <td>{item.budget}</td>
              <td>{item.website}</td>
              <td>{item.createdAt}</td>
            </tr>
          )
        })}
      </table>
      <Footer />
    </div>
  )
}
